// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.tag-list[data-v-6fb24c14] {\n  list-style-type: none;\n  padding: 0;\n  margin: 0 0 20px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: center;\n}\n.tag-button[data-v-6fb24c14] {\n  border-width: 2px;\n  border-style: solid;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
